import React from "react";
import {Radio} from "@mui/material";


const  RadioOption = () => {
    const [contactOptions, setContactOptions] = React.useState('e-mail')
    return (
        <Radio
            label="How can we contact you"
            onChange={e => setContactOptions(e.target.value)}
            options={[
                {
                    label: 'By E-mail',
                    value: 'e-mail',
                },
                {
                    label: 'By Phone',
                    value: 'phone',
                },
                {
                    label: 'By Post',
                    value: 'post',
                },
            ]}
            value={contactOptions}
        />
    )
}
export default RadioOption
